
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { SearchService } from '../../../common/services/search.service';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { MunicipalityService } from '../../../common/services/municipality.service';
import { MunicipalitySummary } from '../../../common/models/municipality';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-municipalities',
    templateUrl: './municipalities.component.html',
    styleUrl: './municipalities.component.scss',
    imports: [MatCardModule, MatMenuModule, MatButtonModule, MatPaginatorModule, MatTooltipModule, MatIconModule]
})
export class MunicipalitiesComponent implements OnInit {
    private destroy$ = new Subject<void>();

    municipalities: MunicipalitySummary[] = [];
    filteredMunicipalities: MunicipalitySummary[] = [];
    isToggled = false;

    constructor(
      private router: Router,
      private municipalityService: MunicipalityService,
      private searchService: SearchService,
      public themeService: CustomizerSettingsService
    ) {}
  
    ngOnInit() {
      this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe(isToggled => {
        this.isToggled = isToggled;
      });
      this.searchService.currentSearchTerm$.pipe(takeUntil(this.destroy$)).subscribe(term => {
        this.applySearch(term);
      });
   
      this.fetchApplications();
    }

    ngOnDestroy() {
     this.destroy$.next();
     this.destroy$.complete();
    }
  
    fetchApplications(): void {
        this.municipalityService.getMunicipalities().pipe(takeUntil(this.destroy$)).subscribe({
          next: (data) => {
            this.municipalities = data;
            this.filteredMunicipalities = [...this.municipalities];
          },
          error: (error) => {
            console.error('Error fetching municipalities', error);
          }
        });
    }

    applySearch(searchTerm: string): void {
      searchTerm = searchTerm.trim().toLowerCase();
      if (searchTerm) {
        this.filteredMunicipalities = this.municipalities.filter((municipality: MunicipalitySummary) => {
          return (
            municipality.email?.toLowerCase().includes(searchTerm) ||
            municipality.name?.toLowerCase().includes(searchTerm)
          );
        });
      } else {
        this.filteredMunicipalities = [...this.municipalities];
      }
    }

    goToEditMunicipality(municipality: MunicipalitySummary): void {
      this.router.navigate(['administrator', 'municipalities', municipality.id.toString(), 'edit']);
    }
  }
